import { MediaDTO } from '../../dto/MediaDto';
import { Filter } from './chip/container/ChipContainer';
import { OptionsType } from '../../components/filterTypes/multiselectbox/types';
import { MaterialDTO } from '../../dto/MaterialDTO';
import { MaterialCategoryDTO } from '../../dto/MaterialCategoryDTO';

export const prepareFilterResistance = (resistances: string[], name: string): Filter[] => {
    if (resistances.length === 0) {
        return [];
    }

    const resistanceTypeSelected: Filter[] = []
    const resistanceTypeSelectedFilters: Filter[] = []

    for (let index = 0; index < resistances.length; index++) {
        if (index === 0) {
            resistanceTypeSelected.push({
                key: name || "filterResistanceType",
                label: resistances[index],
                filters: [],
            })
        } else {
            resistanceTypeSelectedFilters.push({
                key: `${name || "filterResistanceType"} - ${index}`,
                label: resistances[index],
            })
        }
    }

    const formattedResistances = [{
        key: resistanceTypeSelected[0].key,
        label: resistanceTypeSelected[0].label,
        filters: resistanceTypeSelectedFilters
    }]

    return formattedResistances;
}

export const prepareMediaFilter = (media: MediaDTO[] | OptionsType, name: string): Filter[] => {
    if (media.length === 0) {
        return [];
    }

    const mediaSelected: Filter[] = []
    const mediaSelectedFilters: Filter[] = []

    for (let index = 0; index < media.length; index++) {
        if (index === 0) {
            mediaSelected.push({
                key: name || "mediaFilter",
                label: media[index].translationKey,
                filters: [],
            })
        } else {
            mediaSelectedFilters.push({
                key: media[index].id,
                label: media[index].translationKey,
            })
        }
    }

    const formattedMedia = [{
        key: mediaSelected[0].key,
        label: mediaSelected[0].label,
        filters: mediaSelectedFilters
    }]

    return formattedMedia;
}

export const prepareMaterialFilter = (materials: MaterialDTO[] | OptionsType, name: string): Filter[] => {
    if (materials.length === 0) {
        return [];
    }

    const materialSelected: Filter[] = []
    const materialSelectedFilters: Filter[] = []

    for (let index = 0; index < materials.length; index++) {
        if (index === 0) {
            materialSelected.push({
                key: name || "materialFilter",
                label: materials[index].translationKey,
                filters: [],
            })
        } else {
            materialSelectedFilters.push({
                key: materials[index].id,
                label: materials[index].translationKey,
            })
        }
    }

    const formattedMaterials = [{
        key: materialSelected[0].key,
        label: materialSelected[0].label,
        filters: materialSelectedFilters
    }]

    return formattedMaterials;
}

export const prepareMaterialCategoryFilter = (materialCategories: MaterialCategoryDTO[] | OptionsType, name: string): Filter[] => {
    if (materialCategories.length === 0) {
        return [];
    }

    const materialCategorySelected: Filter[] = []
    const materialCategorySelectedFilters: Filter[] = []

    for (let index = 0; index < materialCategories.length; index++) {
        if (index === 0) {
            materialCategorySelected.push({
                key: name || "materialCategoryFilter",
                label: materialCategories[index].translationKey,
                filters: [],
            })
        } else {
            materialCategorySelectedFilters.push({
                key: materialCategories[index].id,
                label: materialCategories[index].translationKey,
            })
        }
    }

    const formattedMaterialCategories = [{
        key: materialCategorySelected[0].key,
        label: materialCategorySelected[0].label,
        filters: materialCategorySelectedFilters
    }]

    return formattedMaterialCategories;
}